import { supabase } from "../lib/supabase";
import type {
  CommissionOverride,
  CreateCommissionOverrideData,
  UpdateCommissionOverrideData,
} from "../types/commission-override";

export const TABLE_NAME = "worker_commission_overrides";

/**
 * Fetch all commission overrides for a specific worker
 */
export async function getCommissionOverridesByWorker(
  workerId: number
): Promise<CommissionOverride[]> {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select("*")
    .eq("worker_id", workerId)
    .order("valid_from", { ascending: false });

  if (error) {
    console.error("Error fetching commission overrides:", error);
    throw error;
  }
  return data || [];
}

/**
 * Create a new commission override
 */
export async function createCommissionOverride(
  data: CreateCommissionOverrideData
): Promise<CommissionOverride> {
  const { data: newOverride, error } = await supabase
    .from(TABLE_NAME)
    .insert([data])
    .select()
    .single();

  if (error) {
    console.error("Error creating commission override:", error);
    throw error;
  }
  return newOverride;
}

/**
 * Update an existing commission override
 */
export async function updateCommissionOverride(
  id: number,
  updates: UpdateCommissionOverrideData
): Promise<CommissionOverride> {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .update(updates)
    .eq("id", id)
    .select()
    .single();

  if (error) {
    console.error("Error updating commission override:", error);
    throw error;
  }
  return data;
}

/**
 * Delete a commission override
 */
export async function deleteCommissionOverride(id: number): Promise<void> {
  const { error } = await supabase.from(TABLE_NAME).delete().eq("id", id);

  if (error) {
    console.error("Error deleting commission override:", error);
    throw error;
  }
}
